import Vue from 'vue';
import Vuex from 'vuex';
import cookies from 'vue-cookies';
import axios from './../axios';
import router from './../router';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        idToken: null,
        userId: null,
        userEmail: '',
        userName: '',
        birdCage: null,
        navOpen: false,
        loginOpen: false,
        basketId: 0,
        basketItems: [],
        basketSubTotal: 0,
        basketVatTotal: 0,
        images: [],
        delivery: 1,
        deliveryPrice: 5,
        total: 0,
        invoiceAddress: {},
        deliveryAddress: {},
    },
    mutations: {
        authUser(state, userData) {
            state.idToken = userData.token;
            state.userId = userData.userId;
            state.birdCage = userData.birdCage;
            state.userEmail = userData.email;
            state.userName = userData.userName;
        },
        clearAuthData(state) {
            state.idToken = null;
            state.userId = null;
            state.userName = '';
            state.birdCage = null;
            state.userEmail = '';
        },
        toggleNav(state, directionData) {
            if (directionData.direction === 'open') {
                state.navOpen = true;
            } else {
                state.navOpen = false;
            }
        },
        openLoginBox(state) {
            state.loginOpen = true;
        },
        closeLoginBox(state) {
            state.loginOpen = false;
        },
        setBasketId(state, idData) {
            state.basketId = idData.basketId;
        },
        setBasketSubTotal(state, amount) {
            state.basketSubTotal = amount.basketSubTotal;
        },
        setBasketVatTotal(state, amount) {
            state.basketVatTotal = amount.basketVatTotal;
        },
        setBasketItems(state, itemData) {
            state.basketItems = itemData.items;
        },
        basketItems(state, itemData) {
            state.basketItems = state.basketItems.concat(itemData.items);
        },
        addImages(state, imageData) {
            state.images = state.images.concat(imageData.images);
        },
        setDelivery(state, deliveryData) {
            state.delivery = deliveryData.delData.delivery;
            state.deliveryPrice = deliveryData.delData.deliveryPrice;
        },
        updateTotal(state, totalValue) {
            state.total = totalValue.value;
        },
        setAddresses(state, addressData) {
            state.invoiceAddress = addressData.addresses.invoice;
            state.deliveryAddress = addressData.addresses.delivery;
        },
    },
    actions: {
        removeFromBasket({ dispatch }, item) {
            axios.get(`/baskets/removeItem/${item}.json`)
                .then(() => {
                    dispatch('checkBasket');
                });
        },
        checkBasket({ state, commit }) {
            let basketId = cookies.get('basket');
            if (basketId) {
                axios.get(`/baskets/getBasket/${basketId}.json`)
                .then((response) => {
                    const items = [];
                    let subTotal = 0;
                    let vat = 0;
                    for (let i = 0; i < response.data.basket.garments.length; i += 1) {
                        items.push(response.data.basket.garments[i]);
                        // eslint-disable-next-line
                        subTotal += (response.data.basket.garments[i].price * response.data.basket.garments[i].quantity);
                        // eslint-disable-next-line
                        subTotal += ((response.data.basket.garments[i].design_price / 100) * response.data.basket.garments[i].quantity);
                        // eslint-disable-next-line
                        vat += (response.data.basket.garments[i].vat * response.data.basket.garments[i].quantity);
                        // eslint-disable-next-line
                        vat += ((response.data.basket.garments[i].design_vat / 100) * response.data.basket.garments[i].quantity);
                    }
                    commit('setBasketItems', { items });
                    commit('setBasketId', { basketId });
                    state.basketSubTotal = subTotal;
                    state.basketVatTotal = vat;
                    axios.get(`/Files/getBasketFiles/${basketId}.json`)
                    .then((responseTwo) => {
                        const images = [];
                        for (let i = 0; i < responseTwo.data.files.length; i += 1) {
                            images.push(responseTwo.data.files[i].id);
                        }
                        commit('addImages', { images });
                    });
                });
            } else {
                axios.get('/shop/addBasket.json')
                    .then((response) => {
                        cookies.set('basket', response.data.basketId, 60 * 60 * 24 * 90);
                        basketId = response.data.basketId;
                        commit('setBasketId', { basketId });
                    });
            }
        },
        saveToken({ commit }, authData) {
            commit('authUser', {
                token: authData.token,
                userId: authData.userId,
                birdCage: authData.cage,
                email: authData.email,
            });
            const expirationDate = authData.expiresIn;
            localStorage.setItem('token', authData.token);
            localStorage.setItem('userId', authData.userId);
            localStorage.setItem('birdCage', authData.cage);
            localStorage.setItem('expiryDate', expirationDate);
            localStorage.setItem('userName', authData.username);
            localStorage.setItem('lastLogIn', authData.lastlogin);
            localStorage.setItem('email', authData.email);
        },
        getToken({ commit }, authData) {
            axios.get(`/Users/getToken/${authData.hash}/${authData.cn}.json`)
                .then((res) => {
                    commit('authUser', {
                        token: res.data.response.token,
                        userId: res.data.response.user,
                        birdCage: res.data.response.cage,
                        userName: res.data.response.username,
                        lastLogIn: res.data.response.lastlogin,
                        email: res.data.response.email,
                    });
                    const expirationDate = res.data.response.expiresIn;
                    localStorage.setItem('token', res.data.response.token);
                    localStorage.setItem('userId', res.data.response.userId);
                    localStorage.setItem('birdCage', res.data.response.cage);
                    localStorage.setItem('expiryDate', expirationDate);
                    localStorage.setItem('userName', res.data.response.username);
                    localStorage.setItem('lastLogIn', res.data.response.lastlogin);
                    localStorage.setItem('email', res.data.response.email);
                    router.push({ path: '/' });
                });
        },
        checkStoredToken({ commit }) {
            const localToken = localStorage.getItem('token');
            const localUserId = localStorage.getItem('userId');
            const localCage = localStorage.getItem('birdCage');
            const localExpiryDate = localStorage.getItem('expiryDate');
            const localUserName = localStorage.getItem('userName');
            const localLastLogIn = localStorage.getItem('lastLogIn');
            const localEmail = localStorage.getItem('email');
            const now = new Date();
            const ts = Math.round((now.getTime() / 1000));
            if (localToken && ts <= localExpiryDate) {
                commit('authUser', {
                    token: localToken,
                    userId: localUserId,
                    birdCage: localCage,
                    userName: localUserName,
                    lastLogIn: localLastLogIn,
                    email: localEmail,
                });
            }
        },
        logout({ commit }) {
            commit('clearAuthData');
            localStorage.removeItem('token');
            localStorage.removeItem('expiryDate');
            localStorage.removeItem('userId');
            localStorage.removeItem('birdCage');
            localStorage.removeItem('userName');
            localStorage.removeItem('lastLogIn');
            localStorage.removeItem('email');
            router.push({ path: '/' });
        },
        toggleNav({ commit }, directionData) {
            commit('toggleNav', {
                direction: directionData.direction,
            });
        },
        openLogin({ commit }) {
            commit('openLoginBox');
        },
        closeLogin({ commit }) {
            commit('closeLoginBox');
        },
        setBasketId({ commit }, basketId) {
            commit('setBasketId', {
                id: basketId,
            });
        },
        addGarmentToBasket({ state, commit }, itemData) {
            const sizes = [];
            for (let i = 0; i < itemData.length; i += 1) {
                if (itemData[i].number) {
                    const sizeValue = {};
                    sizeValue.id = itemData[i].id;
                    sizeValue.qty = itemData[i].number;
                    sizes.push(sizeValue);
                }
            }
            const postData = {};
            postData.basket = state.basketId;
            postData.type = 'garment';
            postData.items = sizes;
            axios.post('/Shop/addToBasket.json', postData)
            .then(() => {
                const basketId = state.basketId;
                axios.get(`/baskets/getBasket/${basketId}.json`)
                .then((response) => {
                    const items = [];
                    for (let i = 0; i < response.data.basket.garments.length; i += 1) {
                        items.push(response.data.basket.garments[i]);
                    }
                    const basketSubTotal = response.data.basket.subTotal;
                    // eslint-disable-next-line
                    const basketVatTotal = (response.data.basket.designVat + response.data.basket.garmentVat);
                    commit('setBasketItems', { items });
                    commit('setBasketId', { basketId });
                    commit('setBasketSubTotal', { basketSubTotal });
                    commit('setBasketVatTotal', { basketVatTotal });
                    axios.get(`/Files/getBasketFiles/${basketId}.json`)
                    .then((responseTwo) => {
                        const images = [];
                        for (let i = 0; i < responseTwo.data.files.length; i += 1) {
                            images.push(responseTwo.data.files[i].id);
                        }
                        commit('addImages', { images });
                    });
                });
            });
        },
        addImages({ commit }, imageData) {
            commit('addImages', {
                images: imageData,
            });
        },
        updateDelivery({ commit }, deliveryValue) {
            const delData = {};
            delData.delivery = 0;
            delData.deliveryPrice = 0;
            if (deliveryValue === '1') {
                delData.delivery = 1;
                delData.deliveryPrice = 5;
            }
            if (deliveryValue === '2') {
                delData.delivery = 2;
                delData.deliveryPrice = 10;
            }
            if (deliveryValue === '3') {
                delData.delivery = 3;
                delData.deliveryPrice = 0;
            }
            commit('setDelivery', {
                delData,
            });
        },
        setTotal({ commit }, totalValue) {
            commit('updateTotal', { value: totalValue });
        },
        saveAddresses({ commit }, addressData) {
            commit('setAddresses', { addresses: addressData });
        },
    },
    getters: {
        isAuthenticated(state) {
            return state.idToken !== null;
        },
        authData(state) {
            const authorizationData = {};
            authorizationData.user = state.userId;
            authorizationData.cage = state.birdCage;
            authorizationData.token = state.idToken;
            authorizationData.userEmail = state.userEmail;
            return authorizationData;
        },
        userName(state) {
            return state.userName;
        },
        userEmail(state) {
            return state.userEmail;
        },
        navOpen(state) {
            return state.navOpen;
        },
        loginOpen(state) {
            return state.loginOpen;
        },
        basketId(state) {
            return state.basketId;
        },
        basketItems(state) {
            return state.basketItems;
        },
        basketSubTotal(state) {
            return state.basketSubTotal;
        },
        basketVatTotal(state) {
            return state.basketVatTotal;
        },
        basketCount(state) {
            return state.basketItems.length;
        },
        images(state) {
            return state.images;
        },
        delivery(state) {
            return state.delivery;
        },
        deliveryPrice(state) {
            return state.deliveryPrice;
        },
        paymentTotal(state) {
            return (state.total * 100);
        },
        deliveryAddress(state) {
            return (state.deliveryAddress);
        },
        invoiceAddress(state) {
            return (state.invoiceAddress);
        },
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js